import styled from "styled-components";

export const ColumnChartContainer = styled.div`
    padding: 4px 16px 0 24px;
`;
